const mapStoreMenu = $('.js-mapStoreMenu');

export function mapstoreMenuClose () {
	$('.js-mapStoreMenu').removeClass('is_open');
}

$(document).on('click', '.js-openMapStoreMenu', function() {
	if (!$(this).hasClass('is_open')) {
		mapStoreMenu.addClass('is_open');
	}
});

$(document).on('click', '.js-closeMapStoreMenu', function() {
	setTimeout(function() {
		mapstoreMenuClose();
	}, 10)
});

